const InfoFill: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Action/info-fill">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22C6.47715 22 2 17.5229 2 12C2 6.47715 6.47715 2 12 2ZM12.7937 16.7619C12.7937 17.2002 12.4383 17.5556 12 17.5556C11.5617 17.5556 11.2063 17.2002 11.2063 16.7619V11.2063C11.2063 10.768 11.5617 10.4127 12 10.4127C12.4383 10.4127 12.7937 10.768 12.7937 11.2063V16.7619ZM10.8095 7.63492C10.8095 8.2924 11.3425 8.8254 12 8.8254C12.6575 8.8254 13.1905 8.2924 13.1905 7.63492C13.1905 6.97744 12.6575 6.44444 12 6.44444C11.3425 6.44444 10.8095 6.97744 10.8095 7.63492Z"
        fill="#1068D0"
      />
    </g>
  </svg>
);

export default InfoFill;
